import { Component } from '@angular/core';

@Component({
  selector: 'app-spinner-overlay',
  template: `
    <div class="spinner-overlay-panel">
      <div class="jump-container">
        <div class="shadow"></div>
        <img class="q-jump" src="assets/img/generic_user_black.png" />
      </div>
      <p class="spinnerText">{{ 'common.loading' | translate }}</p>
    </div>
  `,
  styles: [`
    .spinner-overlay-panel {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100vw;
      height: 100vh;
      background-color: rgba(102,102,102,0.8);
    }

    .jump-container {
      position: relative;
      height: 160px;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      margin-bottom: 1rem;
    }

    .shadow {
      position: absolute;
      bottom: 0;
      width: 80px;
      height: 18px;
      background: rgba(0,0,0,0.35);
      border-radius: 50%;
      filter: blur(3px);
      animation: shadowScale 1s infinite ease-in-out;
      transform-origin: center center;
    }

    .q-jump {
      width: 90px;
      height: 90px;
      position: absolute;
      bottom: 0;
      animation: qJump 1s infinite cubic-bezier(.25,.75,.35,1.0);
      transform-origin: center bottom;
    }

    @keyframes qJump {
      0% {
        transform: translateY(0) scale(1,1);
      }
      10% {
        transform: translateY(0) scale(1.25,0.75);
      }
      30% {
        transform: translateY(-50px) scale(0.92,1.08);
      }
      55% {
        transform: translateY(-90px) scale(1,1); 
      }
      75% {
        transform: translateY(-40px) scale(0.95,1.05);
      }
      90% {
        transform: translateY(0) scale(1.3,0.7); 
      }
      100% {
        transform: translateY(0) scale(1,1);
      }
    }

    @keyframes shadowScale {
      0% {
        transform: scale(1,1);
        opacity: 0.35;
      }
      30% {
        transform: scale(0.8,0.7);
        opacity: 0.25;
      }
      55% {
        transform: scale(0.6,0.5);
        opacity: 0.15;
      }
      75% {
        transform: scale(0.8,0.7);
        opacity: 0.25;
      }
      100% {
        transform: scale(1,1);
        opacity: 0.35;
      }
    }
  `],
  standalone: false,
})
export class SpinnerOverlayComponent {}
